import mutations from "./mutations";
import getters from "./getters";
import { DataService } from "../../../config/dataService/dataService";
import { useMessage } from "../../../composables";
import * as dayjs from "dayjs";

const { successMessage, errorMessage } = useMessage();

const state = () => ({
  loading: false,
  error: null,
  statusCode: 0,
  candidate: {
    items: [],
    totalItems: 0,
  },
  candiadates: [],
  jobposts: {
    items: [],
    totalItems: 0,
  },
  jobApplies: {
    items: [],
    totalItems: 0,
  },
  candidateProfile: [],
  compListForCand: {
    items: [],
    totalItems: 0,
  },
});

const actions = {
  async getAllCandidates({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("admin/candidate/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_ALL_CANDIDATE", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async getAllCompaniesCand({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("candidate/profile/company/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_ALL_COMP_LIST", res.data);
    } catch (error) {
      console.error(error);
    }
  },
  async createCandidate(contex, data, dispatch) {
    const { username, role, ...restobj } = data;

    try {
      const res = await DataService.post(`/admin/candidate/`, {
        user: {
          username: username,
          role: role,
          password: "",
        },
        ...restobj,
      }).then((res) => res);
      if (res.status === 200) {
        successMessage("Candidate is created successfully");
      }
      if (res.status === 401) {
        dispatch("logout");
      }
      return res;
    } catch (err) {
      errorMessage("Something went wrong");

      return err;
    }
  },
  async getSingleCandidate(contex, id) {
    let response = {};
    try {
      const res = await DataService.get(`admin/candidate/${id}`);
      response.candidate = { ...res.data };
    } catch (error) {
      response.candidate = null;
    }

    return response;
  },
  async getCandidates({ commit }) {
    try {
      const res = await DataService.get(`admin/candidate/`);
      commit("SET_GET_CANDIDATES", res.data);
      return res.data;
    } catch (err) {
      return err;
    }
  },

  async updateCandidate({ commit }, data) {
    try {
      let requestBody = {
        user: {
          username: data.username,
          password: "",
          role: "user",
        },
        active: data.active,
        first_name: data.first_name,
        last_name: data.last_name,
        gender: data.gender,
        city: data.city,
        phone: data.phone,
        summary: data.summary,
        job_title: data.job_title,
      };
      if (data.birthday) {
        requestBody.birthday = dayjs(new Date(data.birthday)).format(
          "YYYY-MM-DD"
        );
      }
      let res = await DataService.put(
        `/admin/candidate/${data.id}/`,
        requestBody
      );
      if (data.isStatusUpdated) {
        successMessage("Candidate status has been updated");
        commit("UPDATE_CANDIDATES", data);
      } else {
        successMessage("Candidate is updated successfully");
      }
      return res;
    } catch (err) {
      errorMessage("Something went wrong");

      return err;
    }
  },

  async deleteCandidate(contex, id) {
    try {
      let candidateId = id.toString();
      let res = await DataService.delete(`/admin/candidate/${candidateId}/`);
      successMessage("Candidate deleted successfully");

      return res;
    } catch (err) {
      errorMessage("Something went wrong");
      return err;
    }
  },

  async getCandidateProfile({ commit }) {
    try {
      const res = await DataService.get(`candidate/profile/`);
      commit("SET_CANDIDATE_PROFILE", res.data);
      return res;
    } catch (error) {
      return error;
    }
  },
  async addProfileSkill(context, id) {
    try {
      let res = await DataService.post(`candidate/profile/skill/${id}/`);
      if (res.status === 200) {
        successMessage("Succesfully added skill.");
      }
      return res;
    } catch (error) {
      console.error(error);
      errorMessage("Something went wrong");
      return error;
    }
  },

  async deleteCandidateSkill(context, id) {
    try {
      let res = DataService.delete(`candidate/profile/skill/${id}/`);
      successMessage("Succefully delete skill.");
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async candidateJobApply() {
    try {
      let res = DataService.post(`candidate/profile/job-apply`);
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  async getCandidateJobApplies({ page, itemPerPage }) {
    try {
      let res = DataService.get(`candidate/profile/job-applies/list`, {
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });

      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async candidateSingleJobPost(context, id) {
    try {
      const res = await DataService.get(`candidate/profile/job-posts/${id}`);
      return res.data;
    } catch (error) {
      return error;
    }
  },

  async getAllJobPosts({ commit }, { page, itemPerPage, filters = {} }) {
    try {
      const res = await DataService.post("candidate/profile/job-posts/list", {
        filters: filters,
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });

      commit("SET_ALL_JOBPOSTS", res.data);
    } catch (error) {
      console.error(error);
    }
  },

  async applyJob({ state }, data) {
    try {
      let res = await DataService.post("candidate/profile/job-apply", {
        job_post: data.id,
        date: data.date,
      });
      if (res.status === 200) {
        state.jobposts.items.forEach((item) => {
          if (item.id === data.id) {
            item.applied = true;
          }
        });
        successMessage("Succesfully applied.");
      }
      else {
        errorMessage("You already applied to this job");
      }
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async getAppliedJobs({ commit }, { page, itemPerPage }) {
    try {
      const res = await DataService.post("candidate/profile/job-applies/list", {
        pagination: {
          field: "id",
          ascending: true,
          page: page,
          items_per_page: itemPerPage,
        },
      });
      commit("SET_APPLIED_JOBS", res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  async syncCandidate(context, data) {
    const response = {};
    try {
      let res = await DataService.post(
        `public/sync/candidate?first_name=${data.first_name}&last_name=${data.last_name}`
      );
      response.candidate = { ...res.data.data[0] };
    } catch (error) {
      console.error(error);
      response.candidate = null;
    }
    return response;
  },

  async syncRegisterCandidate(context, data) {
    try {
      let res = await DataService.post(
        `public/sync/candidate/register/${data.id}`,
        {
          username: data.username,
          password: data.password,
          role: "user",
        }
      );
      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async updateCandidateProfile(context, data) {
    try {
      let res = DataService.put(`candidate/profile/update`, {
        first_name: data.first_name,
        last_name: data.last_name,
        gender: data.gender,
        city: data.city,
        summary: data.summary,
        birthday: data.birthday,
        phone: data.phone,
      });
      res?.status === 200 ? successMessage("Succesfully update profile") : "";
      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async updateCandidateExperience(context, data) {
    try {
      let res = await DataService.put(
        `candidate/profile/experience/${data.id}/`,
        {
          candidate: data.id,
          start_date: data.start_date,
          end_date:data.present ? null : data.end_date,
          title: data.title,
          industry: data.industry,
          sector: data.sector,
          function: data.function,
          company: data.company,
          category: data.category,
          department: data.department,
          description: data.description,
          present: data.present,
        }
      );

      res?.status === 200
        ? successMessage("Succesfully update experience")
        : "";

      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async updateCandidateEducation(context, data) {
    try {
      let res = await DataService.put(
        `candidate/profile/education/${data.id}/`,
        {
          candidate: data.candidate,
          institution: data.institution,
          degree: data.degree,
          field_of_study: data.field_of_study,
          year_start: data.year_start,
          year_end: data.year_end,
        }
      );

      res?.status === 200 ? successMessage("Succesfully update education") : "";
      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async deleteCandidateExperience(context, id) {
    try {
      let res = await DataService.delete(`candidate/profile/experience/${id}/`);
      res?.status === 200
        ? successMessage("Succefully delete experience.")
        : "";
      return res;
    } catch (error) {
      errorMessage("Something went wrong.");
      return error;
    }
  },

  async deleteCandidateEducation(context, id) {
    try {
      let res = DataService.delete(`candidate/profile/education/${id}`);
      successMessage("Succefully delete education.");
      return res;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async createCandidateEducation(context, data) {
    try {
      let res = DataService.post("profile/education", {
        candidate: data.candiadate,
        institution: data.institution,
        degree: data.degree,
        field_of_study: data.field_of_study,
        year_start: data.year_start,
        year_end: data.year_end,
      });
      res?.status === 200
        ? successMessage("Succesfully created education.")
        : "";
    } catch (error) {
      console.error(error);
    }
  },

  async createCandidateExperience(context, data) {
    try {
      let res = DataService.post("profile/experience/", {
        candidate: data.candiadate,
        company: data.company,
        start_date: data.start_date,
        end_date: data.end_date,
        industry: data.industry,
        sector: data.sector,
        department: data.department,
        function: data.function,
        category: data.category,
        description: data.description,
      });
      res?.status === 200
        ? successMessage("Succesfully created experience.")
        : "";
    } catch (error) {
      console.error(error);
    }
  },

  async createCandidateTraining(context, data) {
    try {
      let res = await DataService.post("candidate/profile/training/", {
        institution: data.institution,
        certification_field: data.certification_field,
        title: data.title,
        year: Number(data.year),
      });
      res?.status === 200
        ? successMessage("Succesfully created training.")
        : "";
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  },

  async updateCandidateTraining(context, data) {
    try {
      let res = await DataService.put(
        `candidate/profile/training/${data.id}/`,
        {
          institution: data.institution,
          certification_field: data.certification_field,
          title: data.title,
          year: Number(data.year),
        }
      );
      res?.status === 200
        ? successMessage("Succesfully updated training.")
        : "";
      return res;
    } catch (error) {
      console.error(error);
    }
  },
  async getCandidateExperienceList() {
    let response = {};

    try {
      let res = await DataService.get(`candidate/profile/experience/list/`);
      response.experiences = res.data || [];
      return response;
    } catch (error) {
      console.error(error);
      return [];
    }
  },
  async getCandidateEducation() {
    let response = {};

    try {
      let res = await DataService.get(`candidate/profile/education/list/`);
      response.education = res.data;
      return response;
    } catch (error) {
      console.error(error);
      return response;
    }
  },
  async addEducationProfile(context, data) {
    try {
      let res = await DataService.post(`candidate/profile/education/`, {
        candidate: Number(data.candiadate),
        institution: data.institution,
        degree: data.degree,
        field_of_study: data.field_of_study,
        year_start: Number(data.year_start),
        year_end: Number(data.year_end),
      });
      res.status === 200 ? successMessage("Succesfully added education") : "";

      return res;
    } catch (error) {
      console.error(error);
    }
  },
  async addExperienceProfile(context, data) {
    try {
      let res = await DataService.post(`candidate/profile/experience/`, {
        // candidate: Number(data.candiadate),
        company: data.company,
        start_date: data.start_date,
        end_date: data.end_date,
        title: data.title,
        industry: data.industry,
        sector: data.sector,
        department: data.department,
        function: data.function,
        category: data.category,
        description: data.description,
        present: data.present,
      });

      res.status === 200 ? successMessage("Succesfully added experience") : "";

      return res;
    } catch (error) {
      console.error(error);
    }
  },
  async deactivateAccountCandidate() {
    try {
      let res = await DataService.delete(`candidate/profile/`);
      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async addCertificationProfile(context, data) {
    try {
      let res = await DataService.post(`candidate/profile/certification/`, {
        certification_field: data.certification_field,
        title: data.title,
        date_earned: data.date_earned,
        date_expires: data.date_expires,
      });

      res.status === 200
        ? successMessage("Succesfully added certification")
        : "";

      return res;
    } catch (error) {
      console.error(error);
    }
  },

  async updateCertificationProfile(context, data) {
    try {
      let res = await DataService.put(
        `candidate/profile/certification/${data.id}/`,
        {
          certification_field: data.certification_field,
          title: data.title,
          date_earned: data.date_earned,
          date_expires: data.date_expires,
        }
      );
      res.status === 200
        ? successMessage("Succesfully added certification")
        : "";

      return res;
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
